import Image from '@repo/ui/src/components/Image/New';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { HorizontalAlignmentEnum } from '@repo/ui/src/enums/shared-enums';
import { classNames } from '@repo/ui/src/utils/classNames';
import { LinkProps, ImageProps } from '@repo/ui/src/types';
import { navigationClicked } from '@repo/ui/src/services/analytics';

export interface NavigationPromoProps {
  links: Array<LinkProps>;
  title: string;
  image?: ImageProps;
  align?: 'left' | 'center' | 'right';
  primaryHeader?: string;
  secondaryHeader?: string;
}

const fullHorizontalAlignmentClasses = {
  [HorizontalAlignmentEnum.Left]: 'items-left',
  [HorizontalAlignmentEnum.Center]: 'items-center text-center',
  [HorizontalAlignmentEnum.Right]: 'items-end text-right',
};

const NavigationPromo = ({
  title,
  links,
  image,
  align = 'center',
  primaryHeader,
  secondaryHeader,
}: NavigationPromoProps) => {
  return (
    <div
      className="relative w-full h-fit min-h-[118px] rounded"
      role="complementary"
      aria-labelledby="nav-promo-title"
    >
      {image?.image?.url && (
        <div className="absolute inset-0">
          <Image
            src={image.image.url}
            alt="Promo background"
            fill
            className="object-cover rounded"
          />
        </div>
      )}
      <div
        className={classNames(
          'relative flex w-full h-full py-7 px-10 flex-col gap-3 z-10',
          align && fullHorizontalAlignmentClasses[align],
        )}
      >
        <h5 className="tra-text-web-heading-5" id="nav-promo-title">
          {title}
        </h5>
        <div className={classNames('flex flex-row gap-4')}>
          {links?.map((link, i) => (
            <Anchor
              {...link}
              className="tra-text-web-body-m-link"
              key={i}
              onClick={() =>
                navigationClicked({
                  nav_type: 'Top Navigation',
                  clicked_text: link.displayName ?? '',
                  primary_header: primaryHeader ?? '',
                  secondary_header: secondaryHeader ?? '',
                  tertiary_header: `${title ? title + ' ' : ''}${link.displayName}`,
                })
              }
            />
          ))}
        </div>
      </div>
      <div className="absolute inset-0 bg-[rgba(0,0,0,0.4)] rounded" />
    </div>
  );
};

export default NavigationPromo;
